import React from 'react';

const RegulamentoBH = () => {
  return (
    <>
      <h1 className="title">Regulamento</h1>
      <div className="content">
        <p>CAPÍTULO I – DO PRÊMIO</p>
        <br />
        <p>
          Art. 1º – O Prêmio Padocaria BH contribui para a valorização e o
          reconhecimento das padarias, de seus profissionais, de seus serviços e
          de seus produtos, que ajudam a construir a convivência e a gastronomia
          na cidade de Belo Horizonte.
        </p>
        <br />
        <p>
          Art. 2º – Atuando diretamente na valorização das padarias, o Padocaria
          BH também contribui para estimular a população a reconhecer e a
          valorizar as padarias de sua comunidade, de seu bairro e de sua
          cidade.
        </p>
        <br />
        <p>
          Art. 3º – O Prêmio Padocaria BH foi idealizado e é promovido pela
          M.Pad Produções, Marketing e Conteúdo.
        </p>
        <br />
        <p>CAPÍTULO II – DA PARTICIPAÇÃO</p>
        <br />
        <p>
          Art. 1º – O concurso Padocaria BH é aberto à votação do público
          consumidor, que pode indicar seus votos a quaisquer padarias
          estabelecidas dentro dos limites da cidade de Belo Horizonte nas
          seguintes categorias: 1) Pão na Chapa; 2) Pão de Queijo; 3) Pãozinho;
          4) Melhor Time de Atendentes; 5) Almoço em Padaria; 6) Sobremesa de
          Padaria; 7) Café; 8) Melhor Padaria de Belo Horizonte.
          <br />
        </p>
        <br />
        <p>CAPÍTULO III – DAS POSSIBILIDADES DE PREMIAÇÃO</p>
        <br />
        <p>
          Art. 1° – Uma padaria poderá ser premiada em até três categorias e
          poderá sagrar-se vencedora em apenas uma categoria, ainda que receba o
          maior número de votos em duas ou mais categorias. Caso ela receba o
          maior número de votos em mais de uma categoria, ela será considerada,
          para fins de premiação, a vencedora apenas da categoria na qual tiver
          recebido o maior número de votos absolutos.
        </p>
        <br />
        <p>
          Art. 2º – A padaria poderá ser considerada a 2ª colocada apenas na
          categoria na qual recebeu o maior número de votos, exceto na categoria
          da qual foi a vencedora.
        </p>
        <br />
        <p>
          Art. 3º – A padaria poderá ser considerada a 3ª colocada apenas na
          categoria na qual recebeu o maior número de votos, exceto na categoria
          na qual foi a vencedora e na categoria na qual foi a 2ª colocada.
        </p>
        <br />
        <p>
          Art. 4º – Em caso de empate, será considerado como critério de
          desempate o número total de votos recebidos pela padaria em todas as
          categorias. Ao persistir o empate, o prêmio será dividido e entregue a
          ambas.
        </p>
        <br />
        <p>CAPÍTULO IV – DA INDICAÇÃO E DA VOTAÇÃO</p>
        <br />
        <p>
          Art. 1º – A premiação se dará por indicação e voto, única e
          exclusivamente por meio da plataforma digital{' '}
          <a
            href="https://www.padocariabh.com.br"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#40b2f5', textDecoration: 'underline' }}
          >
            www.padocariabh.com.br
          </a>
        </p>
        <br />
        <p>
          Art. 2º – A seleção dos indicados em cada categoria se dará apenas
          pelo voto do público, que pode indicar apenas 1 (um) estabelecimento
          em cada uma das categorias.
        </p>
        <br />
        <p>
          Art. 3º – É permitido indicar a mesma Padaria em uma ou mais
          categorias assim como é permitido indicar uma padaria diferente para
          cada categoria.
        </p>
        <br />
        <p>Art. 4º – É permitido voto em branco.</p>
        <br />
        <p>
          Art. 5º – Cada pessoa pode votar somente uma vez em cada categoria,
          mediante validação prévia de cadastro.
        </p>
        <br />
        <p>
          Art. 6° – O Padocaria BH se compromete a manter a confidencialidade
          das indicações e votos de cada votante. As informações e os resultados
          a serem divulgados não estarão atrelados a nenhuma fonte específica e
          serão apresentados no conjunto da premiação.
        </p>
        <br />
        <p>CAPÍTULO V – DOS RESULTADOS E PREMIAÇÃO</p>
        <br />
        <p>
          Art. 1° – Serão concedidos prêmios (troféus e/ou diplomas) aos
          vencedores de cada categoria do concurso em Belo Horizonte.
        </p>
        <br />
        <p>
          Art. 2º – Serão concedidos menção e troféu às padarias que alcançarem
          o 2º e o 3º lugares na votação das categorias contidas neste
          regulamento.
        </p>
        <br />
        <p>
          Art. 3º – Será enviado por e-mail certificado de participação digital
          a todas as padarias que receberam pelo menos uma indicação, desde que
          se consiga obter um e-mail para contato e envio do mesmo.
        </p>
        <br />
        <p>CAPÍTULO VI – DA DIVULGAÇÃO DO RESULTADO E ENTREGA DOS PRÊMIOS</p>
        <br />
        <p>
          Art. 1° – Os resultados serão divulgados na plataforma oficial{' '}
          <a
            href="https://www.padocariabh.com.br"
            target="_blank"
            rel="noreferrer"
            style={{ color: '#40b2f5', textDecoration: 'underline' }}
          >
            www.padocariabh.com.br
          </a>{' '}
          e redes sociais do Padocaria BH.
        </p>
        <br />
        <p>CAPÍTULO VII – DAS CONSIDERAÇÕES FINAIS</p>
        <br />
        <p>
          Art. 1° – Ao participarem do concurso e do evento de premiação, os
          presentes autorizam automaticamente o Padocaria BH a utilizar, editar,
          publicar, reproduzir por meio impresso, digital, redes sociais e
          outros meios de comunicação visual: imagens, conteúdos, enfim, toda e
          qualquer informação do participante relacionada ao prêmio.
        </p>
        <br />
        <p>
          Art. 2° – Os resultados decorrentes da premiação e divulgados pelo
          Padocaria BH são inquestionáveis e irrecorríveis.
        </p>
        <br />
        <p>
          Art. 3° – Os vencedores poderão utilizar, para fins de divulgação, o
          prêmio Padocaria BH em seu estabelecimento e em todos os seus
          materiais e redes sociais.
        </p>
        <br />
        <p>
          Art. 4° – A participação no Padocaria BH implica a aceitação
          irrestrita deste regulamento.
        </p>
        <br />
        <p>
          Art. 5° – Os casos omissos a este regulamento serão decididos pelos
          organizadores.
        </p>
        <br />
      </div>
    </>
  );
};

export default RegulamentoBH;
